import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';

@Injectable()
export class NotesService {
    private readonly http = inject(HttpClient);
    private readonly config = inject(ConfigService);

    delete(noteId: string): Observable<any> {
        return this.http.delete(
            `${this.config.getConfiguration().API_BASE}/note/${noteId}`,
            {}
        );
    }
}
